<!--
© Copyright 2015-2026 Personalized Privacy Assistant Project, Carnegie Mellon University - All Rights Reserved - US Patent 11,768,949, US Patent 10,956,586, US Patent 12,235,973, and additional USPTO and EPO patents pending.
This code is proprietary and confidential. For any questions about this code, including licensing, please contact Prof. Norman Sadeh (sadeh@cs.cmu.edu).
-->
<template>
  <div>
    <div class="container-fluid">
      <div class="card bg-light mb-3">
        <center><h2 class="card-header">Delete Account Requests</h2></center>
        <div class="card-body">
          <div class="card-text">
            <table class="table table-sm table-hover">
              <thead class="thead-dark">
                <tr>
                  <th scope="col">Request ID</th>
                  <th scope="col">User ID</th>
                  <th scope="col">Reason</th>
                  <th scope="col">Request Date</th>
                  <th scope="col">Status</th>
                  <th scope="col">&nbsp;</th> <!-- Column for buttons to show Revoke Consent Request -->
                </tr>
              </thead>
              <tbody>
                <tr v-for="revokeConsentRequest in revokeConsentRequests">
                  <th>{{revokeConsentRequest.id}}</th>
                  <th>{{revokeConsentRequest.user_id}}</th>
                  <th>{{revokeConsentRequest.reason}}</th>
                  <th>{{formatDate(revokeConsentRequest.created_at)}}</th>
                  <th v-html="status(revokeConsentRequest)"></th>
                  <th><a :href="'/revoke-consent-request/' + revokeConsentRequest.id + '/'" class="btn btn-info" role="button">View Request</a></th>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
      props: {
        route: String,
        permissions: Object,
        revokeConsentRequests: [Object, Array],
      },
      methods: {
        status: function(revokeConsentRequest) {
          if(revokeConsentRequest.completed) {
            return '<i class="fa fa-question-circle text-success mr-2"></i><span class="text-info">Completed</span>';
          } else if(revokeConsentRequest.verified) {
            return '<i class="fa fa-check-circle text-warning mr-2"></i><span class="text-success">Pending</span>';
          } else {
            return '<i class="fa fa-times-circle text-danger mr-2"></i><span class="text-danger">Not Verified</span>';
          }
        },
        formatDate: function(ts) {
          var date = new Date(ts);
          var day = date.getDate();
          var month = date.getMonth() + 1;
          var year = date.getFullYear();

          day = '0' + day;
          month = '0' + month;
          day = (day.length == 2) ? day : day.slice(1);
          month = (month.length == 2) ? month : month.slice(1);

          return year + '-' + month + '-' + day;
        },
      },
      mounted() {
        //
      }
    }
</script>
